import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { Checkbox } from '@change/ds-forms';
import { CheckCircleOutlineIcon } from '@change/ds-icons';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';
import { useTracking } from '@change-corgi/core-react/tracking';

type SubmitModalContentProps = {
	isTermsAgreed: boolean;
	onTermsChange: (checked: boolean) => void;
};

const Item1: React.FC = () => {
	return (
		<li className="flex items-start gap-3">
			<CheckCircleOutlineIcon className="text-stroke-weak mt-0.5 shrink-0" size="medium" aria-hidden />
			<Text variant="body" className="text-typography-strong">
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.confirmation_list_item_1" />
			</Text>
		</li>
	);
};

const Item2: React.FC = () => {
	return (
		<li className="flex items-start gap-3">
			<CheckCircleOutlineIcon className="text-stroke-weak mt-0.5 shrink-0" size="medium" aria-hidden />
			<Text variant="body" className="text-typography-strong">
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.confirmation_list_item_2" />
			</Text>
		</li>
	);
};

export const SubmitModalContent: React.FC<SubmitModalContentProps> = ({ isTermsAgreed, onTermsChange }) => {
	const track = useTracking();

	const handleCheckboxChange = (isSelected: boolean) => {
		if (isSelected) {
			void track('petition_manage_confirm_endorsement_modal_checkbox_click');
		}
		onTermsChange(isSelected);
	};
	return (
		<>
			<Text variant="body" fontWeight="bold" className="text-typography-strong">
				<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.confirm_description" />:
			</Text>
			<ul className="flex list-none flex-col gap-5 pl-0">
				<Item1 />
				<Item2 />
			</ul>
			{/* eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname */}
			<div className="ml-[5px] flex flex-col gap-2">
				<hr className="border-stroke-weaker mt-1 mb-4 border-t" />
				<Checkbox
					name="terms-agreement"
					isSelected={isTermsAgreed}
					onChange={handleCheckboxChange}
					data-qa="terms-agreement-checkbox"
					data-testid="terms-agreement-checkbox"
					className="gap-3 [&>div:first-of-type]:mt-1.5"
				>
					<Text variant="body" size="small" className="text-typography-strong tracking-0 leading-6 font-normal">
						<Translate value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.terms_agreement" />
					</Text>
				</Checkbox>
				<Text
					as="div"
					variant="body"
					size="x-small"
					className="text-typography-weak tracking-0 pl-8 leading-5 font-normal"
				>
					<TranslateHtml
						value="corgi.petition.starter_dashboard_v2.endorsements.submit_modal.change_org_review_notice"
						replacements={{ tosUrl: '/policies/terms-of-service' }}
						allowLinkTargetAttr
					/>
				</Text>
			</div>
		</>
	);
};
